import { combineReducers } from 'redux';
import OrderReducers from '@Reducers/orderReducers';
import UserReducers from '@Reducers/userReducers';
import LoaderReducers from '@Reducers/loaderReducers';
import ProductReducers from '@Reducers/productReducers';
import GRNReducers from '@Reducers/grnReducers';
import TenantReducers from '@Reducers/tenantReducers';
import SellerReducers from '@Reducers/sellerReducers';
import AddressReducer from '@Reducers/addressReducers';
import WorkflowsReducers from '@Reducers/workflowReducers';
import PayoutReducers from '@Reducers/payoutReducers';
import OfferReducers from './offerReducers';
import CartReducers from './cartReducers';
import PaymentOutgoingReducers from './paymentOutgoingReducers';
import ActivityLogReducers from './activityLogReducers';
import AnalyticsReducers from './application/analyticsReducers';
import ForecastReducers from './application/forecastReducers';
import MemberReducers from './memberReducers';

// add to cart
import AddToCartReducers from './addToCart/addToCartReducers';

// Purchase
import PurchaseOrderReducers from './purchaseOrderReducers';
import BulkPOReducers from './purchase/purchaseOrders/bulkPOReducers';
import ExpenseReducers from './purchase/expense/expenseReducers';
import RfqReducers from './purchase/rfq/rfqReducers';

import PaymentRequestReducers from './paymentRequestReducers';
import ReportReducers from './reportReducers';
// reportV2Reducers
import ReportV2Reducers from './ReportsV2/reportV2Reducers';
import UomReducers from './uomReducers';
import TaxReducers from './taxReducers';
import CustomerReducers from './customerReducers';
import InvoiceReducers from './invoiceReducers';
import CNReducers from './cnReducers';
import SOReducers from './sales/soReducers';
import DNReducers from './dnReducers';
import PurchaseRequestReducers from './purchaseRequestReducers';
import DCReducers from './dcReducers';
import DepartmentReducers from './departmentReducers';
import STReducers from './stReducers';
import MOReducers from './moReducers';
import BOMReducers from './bomReducers';
import CategoryReducers from './categoryReducers';
import AttachmentReducers from './attachmentReducers';
import BatchReducers from './batchReducers';
import TagReducers from './tagReducers';

// Production
import ResourceReducers from './production/resourceReducers';
import ProcessReducers from './production/processReducers';
import TemplateRouteReducers from './production/templateRouteReducers';
import JobWorkReducers from './production/jobWorkReducers';
import MrpV2Reducers from './production/mrpV2Reducers';
import ManualProductionEntryReducers from './production/manualProductionEntryReducers';

// Quality
import QCPointReducers from './quality/qcPointReducers';
import QualityCheckReducers from './quality/qualityCheckReducers';

// gate document
import GateDocumentReducers from './logistics/gateDocument/gateDocumentReducers';

// Integrations
import IntegrationReducers from './integrations/integrationReducers';
import TallyIntegrationReducers from './integrations/TallyIntegrationReducers';
import EinvoiceEwaybillReducers from './integrations/EinvoiceEwaybillReducers';
import ZohoIntegrationReducers from './integrations/ZohoIntegrationReducers';
import UnicommerceIntegrationReducers from './integrations/UnicommerceIntegrationReducers';
import ShopifyIntegrationReducers from './integrations/ShopifyIntegrationReducers';
import WhatsappIntegrationReducers from './integrations/WhatsappIntegrationReducers';

// Busy Integration
import BusyIntegrationReducers from './integrations/BusyIntegrationReducers';

// Configurations
import PaymentTermsReducers from './configurations/paymentTermsReducers';
import CustomStatusReducers from './configurations/customStatusReducers';
import CMReducers from './settings/cmReducers';
import GeneralConfigurationReducers from './configurations/generalConfigurationReducers';
import DocConfigReducers from './docConfigReducers';
import TdsTcsReducers from './configurations/tdsTcsReducers';
import CFV2Reducers from './configurations/cfV2Reducers';
import LabelGenerationReducers from './configurations/labelGenerationReducers';

// Vendor Rating

import VendorRatingReducers from './configurations/vendorRatingReducers';

// notification centre
import NotificationCentreReducers from './configurations/notificationCentreReducers';

// Currencies
import CurrenciesReducers from './configurations/currenciesReducer';

// Extra Charges
import ExtraChargesReducers from './configurations/extraChargesReducers';

// Payment Modes
import PaymentModeReducers from './configurations/paymentModeReducer';

// Settings
import InventoryLocationReducers from './settings/inventoryLocationReducers';
import MaskingPolicyReducers from './settings/maskingPolicyReducers';

// Inventory
import ProductBundleReducers from './inventory/productBundleReducers';
import StockMasterReducers from './inventory/stockMasterReducers';
import PriceListReducers from './inventory/priceListReducers';
import DailyRunRateReducers from './inventory/dailyRunRateReducers';

// Reservation
import ReservationReducers from './reservationReducers';

// OCR
import OCRReducers from './ocrReducers';
import ProductV2Reducers from './inventory/productV2Reducers';
import { Reducers } from '../modules';

const RootReducer = (existingState, action) => {
  const AllReducers = new Map();

  AllReducers.set('UserReducers', UserReducers);
  AllReducers.set('LoaderReducers', LoaderReducers);
  AllReducers.set('ProductReducers', ProductReducers);
  AllReducers.set('OrderReducers', OrderReducers);
  AllReducers.set('GRNReducers', GRNReducers);
  AllReducers.set('TenantReducers', TenantReducers);
  AllReducers.set('SellerReducers', SellerReducers);
  AllReducers.set('AddressReducer', AddressReducer);
  AllReducers.set('WorkflowsReducers', WorkflowsReducers);
  AllReducers.set('PayoutReducers', PayoutReducers);
  AllReducers.set('OfferReducers', OfferReducers);
  AllReducers.set('CartReducers', CartReducers);
  AllReducers.set('PaymentOutgoingReducers', PaymentOutgoingReducers);
  AllReducers.set('ProductV2Reducers', ProductV2Reducers);

  // Purchase
  AllReducers.set('PurchaseOrderReducers', PurchaseOrderReducers);
  AllReducers.set('BulkPOReducers', BulkPOReducers);
  AllReducers.set('ExpenseReducers', ExpenseReducers);
  AllReducers.set('RfqReducers', RfqReducers);

  AllReducers.set('PaymentRequestReducers', PaymentRequestReducers);
  AllReducers.set('ReportReducers', ReportReducers);
  AllReducers.set('ReportV2Reducers', ReportV2Reducers);

  AllReducers.set('UomReducers', UomReducers);
  AllReducers.set('TaxReducers', TaxReducers);
  AllReducers.set('CustomerReducers', CustomerReducers);
  AllReducers.set('InvoiceReducers', InvoiceReducers);
  AllReducers.set('CNReducers', CNReducers);
  AllReducers.set('SOReducers', SOReducers);
  AllReducers.set('DNReducers', DNReducers);
  AllReducers.set('PurchaseRequestReducers', PurchaseRequestReducers);
  AllReducers.set('DCReducers', DCReducers);
  AllReducers.set('DepartmentReducers', DepartmentReducers);
  AllReducers.set('STReducers', STReducers);
  AllReducers.set('MOReducers', MOReducers);
  AllReducers.set('BOMReducers', BOMReducers);
  AllReducers.set('CategoryReducers', CategoryReducers);
  AllReducers.set('AttachmentReducers', AttachmentReducers);
  AllReducers.set('BatchReducers', BatchReducers);
  AllReducers.set('TagReducers', TagReducers);

  // Production
  AllReducers.set('ResourceReducers', ResourceReducers);
  AllReducers.set('ProcessReducers', ProcessReducers);
  AllReducers.set('TemplateRouteReducers', TemplateRouteReducers);
  AllReducers.set('JobWorkReducers', JobWorkReducers);
  AllReducers.set('MrpV2Reducers', MrpV2Reducers);
  AllReducers.set('ManualProductionEntryReducers', ManualProductionEntryReducers);

  // Quality
  AllReducers.set('QCPointReducers', QCPointReducers);
  AllReducers.set('QualityCheckReducers', QualityCheckReducers);

  // Gate Document
  AllReducers.set('GateDocumentReducers', GateDocumentReducers);

  // Integrations
  AllReducers.set('IntegrationReducers', IntegrationReducers);
  AllReducers.set('TallyIntegrationReducers', TallyIntegrationReducers);
  AllReducers.set('EinvoiceEwaybillReducers', EinvoiceEwaybillReducers);
  AllReducers.set('ZohoIntegrationReducers', ZohoIntegrationReducers);
  AllReducers.set('UnicommerceIntegrationReducers', UnicommerceIntegrationReducers);
  AllReducers.set('ShopifyIntegrationReducers', ShopifyIntegrationReducers);
  AllReducers.set('WhatsappIntegrationReducers', WhatsappIntegrationReducers);
  AllReducers.set('BusyIntegrationReducers', BusyIntegrationReducers);

  // Configurations
  AllReducers.set('PaymentTermsReducers', PaymentTermsReducers);
  AllReducers.set('ActivityLogReducers', ActivityLogReducers);
  AllReducers.set('CustomStatusReducers', CustomStatusReducers);
  AllReducers.set('GeneralConfigurationReducers', GeneralConfigurationReducers);
  AllReducers.set('DocConfigReducers', DocConfigReducers);
  AllReducers.set('TdsTcsReducers', TdsTcsReducers);
  AllReducers.set('CFV2Reducers', CFV2Reducers);
  AllReducers.set('LabelGenerationReducers', LabelGenerationReducers);

  // VendorRating
  AllReducers.set('VendorRatingReducers', VendorRatingReducers);

  // Currencies
  AllReducers.set('CurrenciesReducers', CurrenciesReducers);

  // Extra Charges
  AllReducers.set('ExtraChargesReducers', ExtraChargesReducers);

  // Payment Modes
  AllReducers.set('PaymentModeReducers', PaymentModeReducers);

  // Settings
  AllReducers.set('InventoryLocationReducers', InventoryLocationReducers);
  AllReducers.set('CMReducers', CMReducers);
  AllReducers.set('MaskingPolicyReducers', MaskingPolicyReducers);

  // Inventory
  AllReducers.set('ProductBundleReducers', ProductBundleReducers);
  AllReducers.set('StockMasterReducers', StockMasterReducers);
  AllReducers.set('PriceListReducers', PriceListReducers);
  AllReducers.set('DailyRunRateReducers', DailyRunRateReducers);

  // Reservation
  AllReducers.set('ReservationReducers', ReservationReducers);

  // OCR
  AllReducers.set('OCRReducers', OCRReducers);

  AllReducers.set('AnalyticsReducers', AnalyticsReducers);
  AllReducers.set('ForecastReducers', ForecastReducers);
  AllReducers.set('MemberReducers', MemberReducers);

  // Notification Centre
  AllReducers.set('NotificationCentreReducers', NotificationCentreReducers);

  // Add to Cart
  AllReducers.set('AddToCartReducers', AddToCartReducers);
  // Bind my custom reducers here
  Reducers().forEach((value, key) => {
    AllReducers.set(key, value);
  });
  // Convert the Map to a plain object
  const reducersObject = Object.fromEntries(AllReducers);

  const AppReducer = combineReducers(reducersObject);
  return AppReducer(existingState, action);
};

export default RootReducer;
